jQuery(document).on("swup:pageView", function () {
  $ = jQuery;

  // Landing Page Template - Copied From Insights Single
  if ($("main.landing-page-template").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    if ($(".insights-slider").length) {
      /*****************************************************************
       * Insights Sliders on / setup for multiple iterations too
       *****************************************************************/

      var insightsSlider = $(".insights-slider");

      insightsSlider.each(function (index, el) {
        var thisSlider = $(el).find(".owl-carousel"),
          quote_count = parseInt(thisSlider.find(".slide").length);

        thisSlider.owlCarousel({
          loop: false,
          rewind: true,
          nav: true,
          navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="25.699" height="21.698" viewBox="0 0 25.699 21.698"><path id="Arrow" d="M26.284,14.506,24.5,12.719,17.41,19.793V.156H14.874V19.793L7.8,12.706,6,14.506,16.142,24.648Z" transform="translate(0.344 26.991) rotate(-90)" fill="none" stroke="#ffffff" stroke-width="1"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="25.699" height="21.698" viewBox="0 0 25.699 21.698"><path id="Arrow" d="M26.284,14.506,24.5,12.719,17.41,19.793V.156H14.874V19.793L7.8,12.706,6,14.506,16.142,24.648Z" transform="translate(0.344 26.991) rotate(-90)" fill="none" stroke="#ffffff" stroke-width="1"/></svg>'],
          items: 1,
          singleItem: true,
          margin: 0,
          dots: true,
          autoHeight: false,
          smartSpeed: 600,
          checkVisibility: true,
          onInitialize: function (e) {
            // Check if only one slide in carousel
            if (quote_count == 1) {
              // console.log("only one");
              this.options.loop = false;
              this.options.nav = false;
              this.options.mouseDrag = false;
            } else {
              this.options.loop = false; // Changed for rewind fix can change back if needed
              this.options.nav = true;
              this.options.mouseDrag = true;
            }
          },
        });

        thisSlider.on("changed.owl.carousel", function (e) {
          var slideIndex = e.item.index,
            bgContain = $(el).find(".bg-contain").children();

          $(el).find(".bg-contain .img-contain").removeClass("active");
          $(bgContain[slideIndex]).addClass("active");
        });

        $(window).on("resize", function () {
          thisSlider.find(".owl-stage-outer").width(innerWidth);
        });
      });
    }

    if ($(".insights-columns").length) {
      /*****************************************************************
    // Mobile Slider for Insights Columns Mobile Section
    *****************************************************************/
      var mobileInsightsColSlider = $(".insights-columns");

      mobileInsightsColSlider.each(function (index, el) {
        var thisSlider = $(el).find(".owl-carousel"),
          quote_count = parseInt(thisSlider.find(".slide").length);

        thisSlider.owlCarousel({
          loop: false,
          rewind: true,
          nav: true,
          navContainer: "[data-slide-num='" + (index + 1) + "']" + " .num-nav",
          navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="25.699" height="21.698" viewBox="0 0 25.699 21.698"><path id="Arrow" d="M26.284,14.506,24.5,12.719,17.41,19.793V.156H14.874V19.793L7.8,12.706,6,14.506,16.142,24.648Z" transform="translate(0.344 26.991) rotate(-90)" fill="none" stroke="#212121" stroke-width="1"/></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="25.699" height="21.698" viewBox="0 0 25.699 21.698"><path id="Arrow" d="M26.284,14.506,24.5,12.719,17.41,19.793V.156H14.874V19.793L7.8,12.706,6,14.506,16.142,24.648Z" transform="translate(0.344 26.991) rotate(-90)" fill="none" stroke="#212121" stroke-width="1"/></svg>'],
          items: 1,
          singleItem: true,
          margin: 0,
          dots: true,
          dotsContainer: "[data-slide-num='" + (index + 1) + "']" + " .num-dots",
          autoHeight: false,
          smartSpeed: 600,
          checkVisibility: true,
          onInitialize: function (e) {
            // Check if only one slide in carousel
            if (quote_count == 1) {
              // console.log("only one");
              this.options.loop = false;
              this.options.nav = false;
              this.options.mouseDrag = false;
            } else {
              this.options.loop = false; // Changed for rewind fix can change back if needed
              this.options.nav = true;
              this.options.mouseDrag = true;
            }
          },
        });

        $(window).on("resize", function () {
          thisSlider.find("owl-stage-outer").width(innerWidth);
        });
      });
    }
  }
});
